export const finishedGoodsStyle = [
  'knitted',
  'hyperoptic',
  'cut & sew',
  'graphic tee',
  'hat',
  'hoodie',
  'packaging',
];
